export function isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]'
}

export function isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]'
}

export function isNil(x) {
  return x === null || x === undefined
}

export function isString(x) {
  return typeof x === 'string'
}

export function hasOwnProperty(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key)
}

export function isBoolean (x) {
  return x === true || x === false
}

export function assert(value, message) {
  if (!value) {
    throw new Error(`http options validate: ${message}`)
  }
}


export function guids() {
  let s = [];
  let hexDigits = '0123456789abcdef';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4';  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';

  var uuid = s.join('');
  return uuid;
}


export function localStorageSet(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function localStorageGet(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return null;
  }
}

export function localStorageRemove(key) {
  localStorage.removeItem(key);
}

